import { ReactElement } from 'react';

import { INSTANCE_ROUTES, PATH_PREFIX_APPINSPECTOR } from '@localstack/constants';

import * as appInspector from '@localstack/appinspector-ui';

import { ResourceBrowserProps } from '../layout';

import * as instanceViews from '../instanceviews';

type InstancePathElementMapEntry = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [componentName: string]: (props: ResourceBrowserProps<any>) => ReactElement;
};

type InstancePathElementMapType = {
  [key: string]: InstancePathElementMapEntry;
};

const buildRouteComponents = (
  routes: Record<string, readonly [string, React.FC]>,
  prefix: string,
  wrapPage: (page: React.FC) => ({ Layout }: instanceViews.InstanceViewProps) => ReactElement,
): Record<string, { Page: ({ Layout }: instanceViews.InstanceViewProps) => ReactElement }> => {
  return Object.fromEntries(
    Object.values(routes).map(([path, page]) => [`${prefix}/${path}`, { Page: wrapPage(page) }]),
  );
};

export const INSTANCE_PATH_ELEMENT_MAP: InstancePathElementMapType = {
  [INSTANCE_ROUTES.STACK_OVERVIEW]: { StackOverview: instanceViews.StackOverview },
  [INSTANCE_ROUTES.IAM_POLICY_STREAM]: { IAMStream: instanceViews.IAMStream },
  [INSTANCE_ROUTES.RESOURCES_OVERVIEW]: { ResourcesOverview: instanceViews.ResourcesOverview },
  [INSTANCE_ROUTES.STATUS]: { SystemStatus: instanceViews.SystemStatus },
  [INSTANCE_ROUTES.INSTANCE_LOGS]: { InstanceLogs: instanceViews.InstanceLogs },
  [INSTANCE_ROUTES.CHAOS_ENGINEERING]: { FISExperiments: instanceViews.FISExperiments },
  [INSTANCE_ROUTES.INSTANCE_SNOWFLAKE]: { Snowflake: instanceViews.Snowflake },
  ...buildRouteComponents(appInspector.pages, PATH_PREFIX_APPINSPECTOR, (PageComponent) =>
    instanceViews.wrapAppInspectorPage(PageComponent),
  ),
};
